"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * On IE11 and Edge, clip-path is not supported.
 * For these browsers, we fallback to a static
 * image that should be already generated/photoshopped
 * with a cut in the photo baked in.
 *
 * https://caniuse.com/#feat=css-clip-path
 */
var FallbackImage = _styledComponents["default"].div.attrs(function (props) {
  return {
    style: {
      backgroundImage: "url(".concat(props.src, ")"),
      backgroundPosition: props.imagePosition
    }
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-size: cover;\n  background-repeat: no-repeat;\n  height: 100%;\n  width: 100%;\n"])));

var _default = FallbackImage;
exports["default"] = _default;